/*jshint esversion: 6 */
import React, {Component} from "react";
import * as ReactDOMServer from "react-dom/server";
import {Button} from "../../components/FormUI";
import './PrintView.css';

export default class PrintView extends Component {
	iframe = null;
	onRef = (r) => {
		this.iframe = r;
	}

	print = () => {
		this.iframe.contentDocument.body.innerHTML = ReactDOMServer.renderToStaticMarkup(this.props.children);
		this.iframe.contentWindow.print();
	}

	render() {
		return (
			<div className={'print-view'}>
				<div className={'controls'}>
					<Button caption={'Print'} onClick={this.print} className={'green'} disabled={this.props.disabled} />
				</div>
				<div className={'print-content'}>{this.props.children}</div>
				<iframe ref={this.onRef} style={ {width: "100%", display: 'none'} }/>
			</div>

		);
	}
}



// WEBPACK FOOTER //
// ./src/views/print/PrintView.jsx